import * as _ from 'lodash'

const filterWords = ['新华丝路', '新华社', '中文摘要', '原文标题', '产品名称']
const patrn = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]/im
export default {
  methods: {
    mergeMoreWords (country, keyWords) {
      if (country && country.length) {
        country = _.filter(country, (item, index) => {
          return index < 4
        })
      }
      keyWords = _.filter(keyWords, (item) => {
        if (item.length < 3) {
          return false
        } else {
          return true
        }
      })
      let arr = []
      country && country.length && arr.push(...country)
      keyWords && keyWords.length && arr.push(...keyWords)
      arr = _.uniq(arr) // 去重
      arr = arr.filter((item) => {
        // debugger
        if (patrn.test(item)) {
          return false
        }
        let noFilter = true
        _.forEach(filterWords, (words) => {
          if (item.indexOf(words) > -1) {
            noFilter = false
          }
        })
        return noFilter
      })
      return arr
    }
  }
}
